interface IJsonLdProps {
  schema: string;
  testId?: string;
}
export const JsonLd = ({ schema, testId }: IJsonLdProps) => {
  const safeSchema = schema.replace(/</g, '\\u003c');

  return (
    <script
      type="application/ld+json"
      data-testid={testId}
      dangerouslySetInnerHTML={{ __html: safeSchema }}
    />
  );
};
